// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "https://raw.githubusercontent.com/AleksHNZ/resume/main/projects/project_1.png",
    title: "Manage Landing Page",
    description: "Great Front End Mentor Challenge, Manage is a landing page with sliders and mobile first design.",
    tech_stack: "HTML, CSS, SCSS, JavaScript",
    github_url: "https://github.com/AleksHNZ/manage-landing-page",
    demo_url: "https://manage-landing-page-indol-kappa.vercel.app/",
  },
  {
    img: "https://raw.githubusercontent.com/AleksHNZ/resume/main/projects/project_2.png",
    title: "Time Tracking Dashboard",
    description:
      "An online diary, that helps to record daily activities and hours spent in a convenient format.",
    tech_stack: "HTML, CSS, JavaScript",
    github_url: "https://github.com/AleksHNZ/time-tracking-dashboard",
    demo_url: "https://time-tracking-dashboard-indol.vercel.app/",
  },
  {
    img: "https://raw.githubusercontent.com/AleksHNZ/resume/main/projects/project_3.png",
    title: "React Calculator",
    description: "Responsive online calculator built with React JS.",
    tech_stack: "ReactJS, CSS",
    github_url: "https://github.com/AleksHNZ/react-calculator-app",
    demo_url: "https://react-mycalculator-app.netlify.app/",
  },
  {
    img: "https://raw.githubusercontent.com/AleksHNZ/resume/main/projects/project_5.png",
    title: "Discord Dashboard",
    description:
      "Discord inspired dashboard with smooth theme switcher, built with Tailwind Css and React JS.",
    tech_stack: "TailWind CSS, ReactJS, CSS",
    github_url: "https://github.com/AleksHNZ/discord-dashboard",
    demo_url: "https://discord-dashboard-app.netlify.app/",
  },

  {
    img: "https://raw.githubusercontent.com/AleksHNZ/resume/main/projects/project_4.png",
    title: "Drum Machine App",
    description:
      "Funny and creative drum machine app that helps you make your own beat.",
    tech_stack: "ReactJS, CSS",
    github_url: "https://github.com/AleksHNZ/react-drummachine",
    demo_url: "https://react-drammachine-app.netlify.app/",
  },

  {
    img: "https://raw.githubusercontent.com/AleksHNZ/resume/main/projects/project_6.png",
    title: "Bookmark Landing Page",
    description:
      "Responsive Landing Page.",
    tech_stack: "HTML, CSS, JavaScript",
    github_url: "https://github.com/AleksHNZ/bookmark-landing-page",
    demo_url: "https://alekshnz.github.io/bookmark-landing-page/",
  },

];



// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/html5.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/css3.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/javascript.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/react.svg",
    name: "ReactJS",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/bootstrap.svg",
    name: "Bootstrap",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/sass.svg",
    name: "Scss",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/git.svg",
    name: "Git",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/responsive.svg",
    name: "Responsive",
  },
  {
    img: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/nodejs/nodejs.png",
    name: "NodeJS",
  },
  {
    img: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/python/python.png",
    name: "Python",
  },
  {
    img: "https://img.icons8.com/ios/344/api-settings.png",
    name: "RestAPI",
  },
  {
    img: "https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg",
    name: "MongoDB",
  },
];
